import { PERMISSION_TYPES } from 'src/enums/permissions';
import { USER_REQUEST_STATUS_NAME } from 'src/enums/user/request-status-name';

export const USER_REQUEST_STATUS_PERMISSION = {
    [USER_REQUEST_STATUS_NAME.PENDING]: PERMISSION_TYPES.USER_REQUEST_PENDING_REQUEST,
    [USER_REQUEST_STATUS_NAME.APPROVED]: PERMISSION_TYPES.USER_REQUEST_APPROVED_REQUEST,
    [USER_REQUEST_STATUS_NAME.CANCELED]: PERMISSION_TYPES.USER_REQUEST_CANCELED_REQUEST,
};
